module.exports = __webpack_public_path__ + "img/Stemness-BLCA_GSE171351.202f81cd.png";